import { Button, Link } from '@amzn/awsui-components-react';
import React from 'react';
import { useChallenges } from '../../store/challenge.context';
import { useEditEvent } from '../../store/edit-event.context';
import { ChallengeDescriptor, ChallengeListItem } from '../../types/Challenge';

interface BackupChallengeRowProps {
  challengeDescriptor: ChallengeDescriptor;
  moveUp: (cd: ChallengeDescriptor) => void;
  moveDown: (cd: ChallengeDescriptor) => void;
  remove: (cd: ChallengeDescriptor) => void;
  toggleChallengeInfo: (challenge: ChallengeListItem) => void;
  index: number;
  totalCount: number;
}

export const BackupChallengeRow: React.FC<BackupChallengeRowProps> = ({
  challengeDescriptor,
  moveUp,
  moveDown,
  remove,
  toggleChallengeInfo,
  index,
  totalCount,
}) => {
  const { selectedChallengesById, getChallengeListItemFromChallengeId } = useChallenges();
  const { editMode, newEventMode } = useEditEvent();
  const challengeListItem =
    selectedChallengesById?.find((ch) => ch.challengeId === challengeDescriptor.challengeId) ??
    (challengeDescriptor.challengeId ? getChallengeListItemFromChallengeId(challengeDescriptor.challengeId) : null);
  return challengeListItem ? (
    <div key={`backup-challenge-${index}`}>
      {(editMode || newEventMode) && (
        <React.Fragment>
          <Button
            disabled={index >= totalCount - 1}
            iconName="angle-down"
            variant="inline-icon"
            onClick={() => moveDown(challengeDescriptor)}
            data-testid="backupChallengeDownButton"
          />
          <Button
            disabled={index <= 0}
            iconName="angle-up"
            variant="inline-icon"
            onClick={() => moveUp(challengeDescriptor)}
            data-testid="backupChallengeUpButton"
          />
        </React.Fragment>
      )}
      <strong>{index + 1}. </strong>
      <Link className="mr-5" onFollow={() => toggleChallengeInfo(challengeListItem)}>
        {challengeListItem?.props.title}
      </Link>
      <span>({challengeListItem?.challengeId})</span>
      {(editMode || newEventMode) && (
        <Button
          onClick={() => remove(challengeDescriptor)}
          iconName="close"
          variant="inline-icon"
          data-testid="removeBackupChallengeButton"
        />
      )}
    </div>
  ) : null;
};
